module.exports = {
  "wxc-page-calendar": {
    "position": "fixed",
    "top": 0,
    "right": -750,
    "width": 750,
    "color": "#333333",
    "backgroundColor": "#ffffff"
  },
  "flex-item": {
    "flex": 1,
    "textAlign": "center"
  },
  "calendar-weekday": {
    "height": 60,
    "backgroundColor": "#ffffff",
    "borderBottomWidth": 1,
    "borderTopWidth": 1,
    "borderColor": "#e2e2e2",
    "flexDirection": "row",
    "justifyContent": "space-around",
    "alignItems": "center"
  },
  "weekday-text": {
    "color": "#000000",
    "flex": 1,
    "textAlign": "center"
  },
  "calendar-list": {
    "flexDirection": "column"
  },
  "calendar-month": {
    "height": 60,
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "#f2f3f4"
  },
  "month-text": {
    "fontSize": 32
  },
  "calendar-row": {
    "height": 140,
    "flexDirection": "row",
    "borderBottomWidth": 1,
    "borderColor": "#f2f3f4",
    "alignItems": "center",
    "justifyContent": "space-between",
    "position": "relative"
  },
  "row-item": {
    "flex": 1,
    "height": 140,
    "background": "#ffffff",
    "borderWidth": 0,
    "paddingTop": 10,
    "paddingBottom": 10
  },
  "calendar-note": {
    "height": 36,
    "lineHeight": 36,
    "fontSize": 24,
    "color": "#000000",
    "textAlign": "center"
  },
  "calendar-item": {
    "justifyContent": "center",
    "alignItems": "center",
    "height": 120
  },
  "calendar-day": {
    "height": 48,
    "lineHeight": 48,
    "fontSize": 36,
    "color": "#000000",
    "textAlign": "center"
  },
  "calendar-ext": {
    "height": 36,
    "lineHeight": 36,
    "color": "#999999",
    "textAlign": "center",
    "fontSize": 24,
    "overflow": "hidden",
    "textOverflow": "ellipsis"
  },
  "calendar-holiday": {
    "color": "#FF5000"
  },
  "calendar-rest": {
    "color": "#FF5000"
  },
  "item-row-selected": {
    "color": "#ffffff",
    "backgroundColor": "#FFC900",
    "textAlign": "center"
  },
  "item-text-selected": {
    "color": "#3d3d3d",
    "textAlign": "center"
  },
  "calendar-disabled": {
    "color": "#CCCCCC"
  },
  "cell-disabled": {
    "backgroundColor": "#FBFBFB"
  },
  "calendar-day-include": {
    "backgroundColor": "#FFF7D6"
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-774c3f00!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-page-calendar/index.vue
// module id = 115
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28